import {
	Button,
	colors,
	Flex,
	Icon,
	IconTypes,
	INNER_MAX_WIDTH,
	Text,
} from "@capioweb/ui-components/src"
import React from "react"
import styled from "styled-components"
import { sendVisitedDiagnosesClickDataLayerPush } from "../../utils"

interface Item {
	href: string
	icon?: IconTypes
	text: string
}

interface MostVisitedDiagnosesCardProps {
	cta: {
		text: string
		href: string
	}
	description: string
	header: string
	items: Item[]
}

const StyledItem = styled(Flex)`
	&:hover {
		text-decoration: underline;

		> h3 {
			color: ${colors.hoverBlue};
		}
	}
`

const StyledText = styled(Text)`
	::first-letter {
		text-transform: capitalize;
	}
`

export const MostVisitedDiagnosesCard: React.FC<MostVisitedDiagnosesCardProps> =
	({ cta, description, header, items }) => {
		return (
			<Flex
				flexDirection={"column"}
				backgroundColor={"purple33"}
				alignItems={"center"}
				py={6.5}
				width={"100%"}
			>
				<Flex
					alignItems="center"
					flexDirection="column"
					w={1}
					maxw={INNER_MAX_WIDTH}
					m="0 auto"
				>
					<Flex flexDirection={"column"} alignItems={"center"} width={"100%"}>
						<Text variant={"headline-2"} textAlign={"center"}>
							{header}
						</Text>
						<Flex
							alignSelf={"center"}
							w={{ _: "100%", l: "60%" }}
							justifyContent={"center"}
						>
							<Text textAlign={"center"}>{description}</Text>
						</Flex>
					</Flex>
					<Flex
						flexWrap={"wrap"}
						flexDirection={"row"}
						justifyContent={"center"}
					>
						{items.map((item, index) => {
							return (
								<StyledItem
									alignItems={"center"}
									as={"a"}
									href={item.href}
									key={index}
									mx={3}
									mb={1.5}
									onClick={() =>
										sendVisitedDiagnosesClickDataLayerPush(item.text)
									}
								>
									{item.icon && (
										<Icon color={"navy"} icon={item.icon} mr={1} size={4} />
									)}
									<StyledText variant={"headline-3"} mb={0}>
										{item.text}
									</StyledText>
								</StyledItem>
							)
						})}
					</Flex>
					<Flex justifyContent={"center"} py={2}>
						<Button.Anchor
							href={cta.href}
							variant="navy"
							textTransform={"uppercase"}
							onClick={() => sendVisitedDiagnosesClickDataLayerPush(cta.text)}
						>
							{cta.text}
						</Button.Anchor>
					</Flex>
				</Flex>
			</Flex>
		)
	}
